import { axiosPrivate } from "../utils/axios";

// Token and 401 / refresh handling for axiosPrivate is done globally in
// utils/AxiosInterceptor. `type` is kept so existing callers don't change.
const UseAxiosPrivate = (type="empty") => {
    return axiosPrivate;
}

export default UseAxiosPrivate;
